import {
  WorkflowService,
  WorkflowTypes
} from '../NewWorkflow/newWorkflowReducer';
import {
  DuplicateWorkflowAction,
  DuplicateWorkflowActionKind,
  DuplicateWorkflowState,
  SelectedForm
} from './types';

export const initialState: DuplicateWorkflowState = {
  forms: [],
  isLoading: false,
  workflowType: WorkflowTypes.OHS,
  newWorkflowName: '',
  hasError: false,
  errorMessage: '',
  selectedForm: null,
  selectedId: ''
};

export function duplicateWorkflowReducer(
  state: DuplicateWorkflowState,
  action: DuplicateWorkflowAction
) {
  const { type, payload } = action;

  switch (type) {
    case DuplicateWorkflowActionKind.SET_FORMS:
      return {
        ...state,
        forms: payload as WorkflowService[]
      };

    case DuplicateWorkflowActionKind.SET_ISLOADING:
      return {
        ...state,
        isLoading: payload as boolean
      };

    case DuplicateWorkflowActionKind.SET_NEW_WORKFLOW_NAME:
      return {
        ...state,
        newWorkflowName: payload as string
      };

    case DuplicateWorkflowActionKind.SET_ERROR:
      return {
        ...state,
        hasError: payload as boolean
      };

    case DuplicateWorkflowActionKind.SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: payload as string
      };

    case DuplicateWorkflowActionKind.SET_SELECTED_FORM: {
      const { id, value } = payload as SelectedForm;
      return {
        ...state,
        selectedId: id,
        selectedForm: value
      };
    }

    default:
      return state;
  }
}
